import { track } from "@amplitude/analytics-react-native";
import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { amp } from "src/api/amplitude";
import ReportEntityDocument from "src/api/graphql/__generated__/documents/ReportEntityDocument";
import EntityType from "src/api/graphql/__generated__/enums/EntityType";
import { prompt } from "src/swsh-native";
import toast from "src/swsh-native/toast";

const usePromptReportPhoto = () => {
	const apolloClient = useApolloClient();

	const handleReport = useCallback(
		async (photoId: string) => {
			track(amp.photo.report.initiate, {
				photoId,
			});
			prompt({
				title: "Report",
				message:
					"Please tell us why you are reporting this content. Your message is reported directly to swsh.",
				buttons: [
					{
						style: "destructive",
						text: "Report",
						onPress: async (reason) => {
							track(amp.photo.report.confirm, {
								photoId,
							});
							await apolloClient.mutate({
								mutation: ReportEntityDocument,
								variables: {
									input: {
										entityId: photoId,
										entityType: EntityType.Photo,
										reason: reason,
									},
								},
							});
							toast({
								preset: "done",
								title: "Content reported",
								message: "Thank you for your report",
							});
						},
					},
					{
						style: "cancel",
						text: "Cancel",
						onPress: () => {
							track(amp.photo.report.cancel, {
								photoId,
							});
						},
					},
				],
			});
		},
		[apolloClient],
	);

	return {
		promptReportPhoto: handleReport,
	};
};
export default usePromptReportPhoto;
